import axios from 'axios';

const state = {
  notifications: [],
  unreadCount: 0,
  totalCount: 0,
};

const getters = {
  getNotifications: state => state.notifications,
  getUnreadCount: state => state.unreadCount,
  getTotalCount: state => state.totalCount,
};

const mutations = {
  setNotifications(state, { results, unread_count, count }) {
    state.notifications = results || [];
    state.unreadCount = unread_count || 0;
    if (count !== undefined) {
      state.totalCount = count;
    }
  },
  appendNotifications(state, { results, unread_count, count }) {
    state.notifications = state.notifications.concat(results || []);
    state.unreadCount = unread_count || 0;
    if (count !== undefined) {
      state.totalCount = count;
    }
  },
  addNotification(state, notification) {
    state.notifications.unshift(notification);
    state.totalCount += 1;
  },
  updateUnreadCount(state, count) {
    state.unreadCount = count;
  },
  markNotificationRead(state, notificationId) {
    var n = state.notifications.find(function (item) { return item.id === notificationId; });
    if (n) {
      n.is_read = true;
    }
  },
  markAllNotificationsRead(state) {
    state.notifications.forEach(function (n) { n.is_read = true; });
    state.unreadCount = 0;
  },
  clearNotifications(state) {
    state.notifications = [];
    state.unreadCount = 0;
    state.totalCount = 0;
  },
};

const actions = {
  async getAllNotifications({ commit }, params) {
    var limit = (params && params.limit) || 20;
    var offset = (params && params.offset) || 0;
    var append = params && params.append;

    var res = await axios.get('api/notifications/', { params: { limit: limit, offset: offset } });
    var data = res.data.data || res.data;

    if (append) {
      commit('appendNotifications', data);
    } else {
      commit('setNotifications', data);
    }

    return data;
  },

  async updateNotification({ commit }, { id, data }) {
    var res = await axios.patch('api/notifications/' + id + '/', data);
    if (data.is_read) {
      commit('markNotificationRead', id);
    }
    return res.data;
  },

  async markAllRead({ commit }) {
    await axios.post('api/notifications/mark-all-read/');
    commit('markAllNotificationsRead');
  },

  handleWebSocketMessage({ commit }, message) {
    if (message.action === 'Send') {
      commit('addNotification', message.data);
      commit('updateUnreadCount', message.unread_count);
    } else if (message.action === 'Update') {
      if (message.data && message.data.id) {
        commit('markNotificationRead', message.data.id);
      }
      commit('updateUnreadCount', message.unread_count);
    } else if (message.action === 'MarkAllRead') {
      commit('markAllNotificationsRead');
    }
  },
};

export const notification = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
